var React = require('react');

function Border (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.15045 660L1.15042 1.18531L179.45 1.18532","stroke":"white","strokeWidth":"2","strokeDasharray":"50 10 10 10 10 10","vectorEffect":"non-scaling-stroke"}));
}

Border.defaultProps = {"width":"180","height":"660","viewBox":"0 0 180 660","fill":"none","preserveAspectRatio":"none"};

module.exports = Border;

Border.default = Border;
